import { GREY_COLOR, PURE_BLACK_COLOR } from '../constants';

export { LogoApp } from './LogoApp';

export function TwiplaLogo({ color, ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg width='24' height='24' viewBox='0 0 48 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2857 24H17.1427L6.857 0H0L10.2857 24ZM30.857 24H37.7143L34.2857 16L29.7143 5.333L32 0H20.5713L16 10.667L19.4287 18.667L24 8L26.2857 13.333L30.857 24Z'
        fill={color ?? 'url(#paint0_linear_148_178654)'}
      />
      <path d='M48 0L40 18.667L36.5713 10.667L41.143 0H48Z' fill={color ?? 'url(#paint1_linear_148_178654)'} />
      <defs>
        <linearGradient id='paint0_linear_148_178654' x1='0' y1='12' x2='48' y2='12' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F56600' />
          <stop offset='1' stopColor='#5C04B4' />
        </linearGradient>
        <linearGradient id='paint1_linear_148_178654' x1='0' y1='12' x2='48' y2='12' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F56600' />
          <stop offset='1' stopColor='#5C04B4' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function GoToWebsite({ color = '#999999', ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M11 13L23 1M23 1H15M23 1V9' stroke={color} strokeWidth='2' />
      <path
        d='M9 1H5C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V15'
        stroke={color}
        strokeWidth='2'
      />
    </svg>
  );
}

export function ProfileIcon({
  color = '#009688',
  isActive,
  ...props
}: { isActive?: boolean } & JSX.IntrinsicElements['svg']) {
  return isActive ? (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 20 20'
      xmlSpace='preserve'
      {...props}
    >
      <path
        fill={color}
        d='M17.7,13c-1.8-0.3-3.5-0.7-5.3-1.1c-1,1.5-4.8,1.5-5.7,0c-1.8,0.3-3.6,0.7-5.3,1.1c0,2.3,0,4.7,0,7h16.4
  C17.7,17.7,17.7,15.3,17.7,13z'
      />
      <path
        fill={color}
        d='M10.1,9.7c2-0.2,3.7-1.9,4.1-3.8c0.3-1.6-0.2-3.3-1.3-4.4c-1-1-2.5-1.6-3.9-1.4C7.2,0.2,5.5,1.5,4.9,3.3
  c-0.6,1.6-0.2,3.6,1,4.8C6.9,9.3,8.6,9.9,10.1,9.7z'
      />
    </svg>
  ) : (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 20 20'
      xmlSpace='preserve'
      {...props}
    >
      <path
        d='M18,13c-1.8-0.3-3.5-0.7-5.3-1.1c-0.5,0.7-1.7,1.1-2.9,1.1c-1.2,0-2.4-0.4-2.8-1.1c-1.8,0.3-3.6,0.7-5.3,1.1
        c0,2.3,0,4.7,0,7H18C18,17.7,18,15.4,18,13z M2.5,19.1c0-1.8,0-3.5,0-5.3c1.4-0.3,2.8-0.6,4.1-0.8c0.7,0.6,1.9,1,3.2,1
        c1.3,0,2.5-0.4,3.2-1c0.6,0.1,1.3,0.3,1.9,0.4c0.7,0.1,1.4,0.3,2.2,0.4c0,1.8,0,3.6,0,5.3H2.5z'
      />
      <path
        d='M9.8,9.7c0.2,0,0.4,0,0.7,0c2-0.2,3.7-1.9,4.1-3.8c0.3-1.6-0.2-3.3-1.3-4.4C12.3,0.5,11,0,9.8,0
        C9.6,0,9.5,0,9.3,0C7.5,0.2,5.8,1.5,5.2,3.3C4.6,4.9,5,6.9,6.2,8.1C7.1,9.1,8.4,9.7,9.8,9.7z M6.1,3.6C6.5,2.2,7.9,1.1,9.4,1
        c0.1,0,0.2,0,0.4,0c1.1,0,2.1,0.4,2.8,1.2c0.9,0.9,1.3,2.3,1.1,3.6c-0.3,1.6-1.7,2.9-3.4,3.1c-0.2,0-0.3,0-0.5,0
        c-1.1,0-2.2-0.5-2.9-1.3C5.9,6.5,5.6,4.9,6.1,3.6z'
      />
    </svg>
  );
}

export function BackButtonIcon({ color = GREY_COLOR, ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM10.3447 3.96967L5.84467 8.46967L5.31434 9L5.84467 9.53033L10.3447 14.0303L11.4053 12.9697L7.43566 9L11.4053 5.03033L10.3447 3.96967Z'
        fill={color}
      />
    </svg>
  );
}

export function WebsiteManagementCircle({ color = PURE_BLACK_COLOR, ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg {...props} width='24' height='24' viewBox='0 -2 24 28' xmlns='http://www.w3.org/2000/svg' fill={color}>
      <g fillRule='evenodd'>
        <path d='M13.0679,22.9463 C13.9269,21.9783 15.1189,20.3353 15.9679,18.0003 L21.2079,18.0003 C19.4259,20.7243 16.4739,22.6163 13.0679,22.9463 L13.0679,22.9463 Z M2.7929,18.0003 L8.0319,18.0003 C8.8809,20.3353 10.0729,21.9783 10.9319,22.9463 C7.5259,22.6163 4.5739,20.7243 2.7929,18.0003 L2.7929,18.0003 Z M10.9539,1.0523 C10.0999,2.0263 8.9059,3.6773 8.0509,6.0003 L2.7929,6.0003 C4.5779,3.2693 7.5389,1.3773 10.9539,1.0523 L10.9539,1.0523 Z M21.2079,6.0003 L15.9489,6.0003 C15.0939,3.6773 13.9009,2.0263 13.0469,1.0523 C16.4619,1.3773 19.4219,3.2693 21.2079,6.0003 L21.2079,6.0003 Z M16.9809,11.5003 C16.9349,9.8173 16.6729,8.3153 16.2819,7.0003 L21.7859,7.0003 C22.4849,8.3613 22.9009,9.8843 22.9749,11.5003 L16.9809,11.5003 Z M16.9809,12.5003 L22.9749,12.5003 C22.9009,14.1153 22.4849,15.6383 21.7859,17.0003 L16.2969,17.0003 C16.6799,15.6883 16.9369,14.1883 16.9809,12.5003 L16.9809,12.5003 Z M7.0199,11.5003 L1.0259,11.5003 C1.0989,9.8843 1.5159,8.3613 2.2139,7.0003 L7.7179,7.0003 C7.3269,8.3153 7.0649,9.8173 7.0199,11.5003 L7.0199,11.5003 Z M15.2299,7.0003 C15.6469,8.3003 15.9359,9.8023 15.9849,11.5003 L8.0149,11.5003 C8.0639,9.8023 8.3529,8.3003 8.7699,7.0003 L15.2299,7.0003 Z M14.8729,6.0003 L9.1279,6.0003 C10.0299,3.7283 11.2619,2.1793 11.9999,1.3903 C12.7379,2.1793 13.9699,3.7283 14.8729,6.0003 L14.8729,6.0003 Z M1.0259,12.5003 L7.0189,12.5003 C7.0639,14.1883 7.3199,15.6883 7.7039,17.0003 L2.2139,17.0003 C1.5159,15.6383 1.0989,14.1153 1.0259,12.5003 L1.0259,12.5003 Z M8.7459,17.0003 C8.3409,15.7063 8.0619,14.2063 8.0149,12.5003 L15.9849,12.5003 C15.9389,14.2103 15.6639,15.7093 15.2629,17.0003 L8.7459,17.0003 Z M9.0979,18.0003 L14.9139,18.0003 C14.0079,20.3343 12.7509,21.8703 12.0039,22.6353 C11.2629,21.8693 10.0059,20.3263 9.0979,18.0003 L9.0979,18.0003 Z M11.9999,0.0003 C5.3729,0.0003 -0.0001,5.3733 -0.0001,12.0003 C-0.0001,18.6273 5.3729,24.0003 11.9999,24.0003 C18.6279,24.0003 23.9999,18.6273 23.9999,12.0003 C23.9999,5.3733 18.6279,0.0003 11.9999,0.0003 L11.9999,0.0003 Z' />
      </g>
    </svg>
  );
}

export function PlusInCircleIcon({ color = '#666666', ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='12' cy='12' r='11' stroke={color} strokeWidth='2' />
      <path
        d='M12 6C12 6 12 10.4431 12 12.0006M12 18C12 17.191 12 13.0585 12 12.0006M12 12.0006H6M12 12.0006H18'
        stroke={color}
        strokeWidth='2'
      />
    </svg>
  );
}

export function HamburgerIcon({ color = PURE_BLACK_COLOR, ...props }: JSX.IntrinsicElements['svg']) {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 4C0 3.37868 0.50368 2.875 1.125 2.875H16.875C17.4963 2.875 18 3.37868 18 4C18 4.62132 17.4963 5.125 16.875 5.125H1.125C0.50368 5.125 0 4.62132 0 4ZM0 9.25C0 8.62868 0.50368 8.125 1.125 8.125H16.875C17.4963 8.125 18 8.62868 18 9.25C18 9.87132 17.4963 10.375 16.875 10.375H1.125C0.50368 10.375 0 9.87132 0 9.25ZM1.125 13.375C0.50368 13.375 0 13.8787 0 14.5C0 15.1213 0.50368 15.625 1.125 15.625H10.875C11.4963 15.625 12 15.1213 12 14.5C12 13.8787 11.4963 13.375 10.875 13.375H1.125Z'
        fill={color}
      />
    </svg>
  );
}
